"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step4 = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var Icon_1 = require("components/Icon");
var List_1 = require("./List");
var AddMetaData_1 = require("../Modal/AddMetaData");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var projectWizard = require("@caddigital/sok-reducers/lib/actions/project/wizard");
var Types = require("types");
var mapStateToProps = function (state) {
    return {
        wizard: state.project.wizard,
        step1: state.project.wizard.step1,
        step4: state.project.wizard.step4,
        metaMap: state.project.wizard.step4.metaMap
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    deleteMeta: function (schemaId, uuid) { return function () {
        return dispatch(projectWizard.deleteMetaElement(schemaId, uuid));
    }; },
    fetchMeta: function (x) { return dispatch(projectWizard.fetchMetas(x)); },
    moveMeta: function (schemaId, meta) {
        dispatch(projectWizard.moveMetaElement(schemaId, meta));
    },
    toggleCreateModal: function () { return dispatch(projectWizard.toggleCreate()); },
    toggleEditModal: function (uuid) { return function () {
        return dispatch(projectWizard.toggleEdit(uuid));
    }; }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchMeta(this.props.step1.id);
    }
}), recompose_1.pure);
exports.Step4 = enhance(function (props) { return (React.createElement("div", { className: 'settings-view' },
    React.createElement("div", { className: 'card-box' },
        React.createElement("h2", null,
            React.createElement(Icon_1.Icon, { className: 'fa-database' }),
            ' ',
            (0, translation_1.getLocalization)('admin/projectsTab/editProject/metadata/header')),
        React.createElement("div", { className: 'card-box-content' },
            React.createElement(sok_ui_1.RequestStatusBox, { key: 'request', status: props.step4.editStatus, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/saving'),
                (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/saved'),
                (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/failed')),
            React.createElement(sok_ui_1.RequestStatusBox, { key: 'request', status: props.step4.deleteStatus, statusList: ['STANDBY', 'DELETING', 'DELETED', 'FAILED'] },
                (0, translation_1.getLocalization)('admin/projectsTab/editProject/metadata/deleting'),
                (0, translation_1.getLocalization)('admin/projectsTab/editProject/metadata/deleted'),
                (0, translation_1.getLocalization)('admin/projectsTab/editProject/metadata/failed')),
            React.createElement(List_1.List, __assign({}, props)),
            React.createElement(AddMetaData_1.default, { schemaId: props.step4.schemaId }))))); });
